import { render, staticRenderFns } from "./DeceasedStep.vue?vue&type=template&id=9bf61b12"
import script from "./DeceasedStep.vue?vue&type=script&lang=ts"
export * from "./DeceasedStep.vue?vue&type=script&lang=ts"
import style0 from "./DeceasedStep.vue?vue&type=style&index=0&id=9bf61b12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports